'use client';

import {useState} from "react";
import PropTypes from 'prop-types';
import {useSnackbar} from "notistack";

import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

import {useRouter} from "src/routes/hooks";

import {useAuthContext} from "src/auth/hooks";
import {saveComment} from "src/services/comment/save-api";

import {paths} from "@/routes/paths";
import {getThumbnailUrl} from "@/utils/image-utils";

export default function CommentForm({replyToCommentId = null, afterSubmit = null, recipeId, ...others}) {
  const router = useRouter();
  const [comment, setComment] = useState('');
  const {user} = useAuthContext();
  const {enqueueSnackbar} = useSnackbar();

  const handleSubmit = async () => {
    if (!comment) {
      return;
    }

    if (!user || user.isLoggedIn === false) {
      enqueueSnackbar('Musisz być zalogowany, aby dodawać komentarze.', {variant: 'error'});
      router.push(paths.auth.token.loginWithReturnTo(paths.recipe.details(recipeId)));
      return;
    }

    if (comment.length < 5) {
      enqueueSnackbar('Komentarz musi mieć przynajmniej 5 znaków', {variant: 'error'});
      return;
    }

    await saveComment({replyToCommentId, recipeId, content: comment});
    enqueueSnackbar('Dodano komentarz!');
    setComment('');
    if (afterSubmit) {
      afterSubmit();
    }
  };

  return (
    <Stack direction="column" spacing={2}>
      <Stack
        spacing={2}
        direction="row"
        alignItems="top"
      >
        <Avatar
          src={getThumbnailUrl(user?.photo, '270_270')}
          alt={user?.name}
          sx={{
            my: 1,
            width: 42,
            height: 42,
            border: (theme) => `solid 2px ${theme.palette.background.default}`,
          }}
        >
          {user?.name?.charAt(0).toUpperCase()}
        </Avatar>
        <TextField
          fullWidth
          type="outlined"
          multiline
          rows={2}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
      </Stack>
      <Stack
        direction="row"
        justifyContent={{sm: 'flex-end'}}
      >
        <Button sx={{width: {xs: '100%', sm: 'auto'}}} color="primary" variant="contained" onClick={handleSubmit}>
          {replyToCommentId ? 'Odpowiedz' : 'Dodaj komentarz'}
        </Button>
      </Stack>
    </Stack>
  );
}

CommentForm.propTypes = {
  replyToCommentId: PropTypes.number,
  recipeId: PropTypes.number,
  afterSubmit: PropTypes.func
};
